import { render, staticRenderFns } from "./ReturnProcessToStock.vue?vue&type=template&id=6b9aafa7&scoped=true"
import script from "./ReturnProcessToStock.vue?vue&type=script&lang=js"
export * from "./ReturnProcessToStock.vue?vue&type=script&lang=js"
import style0 from "./ReturnProcessToStock.vue?vue&type=style&index=0&id=6b9aafa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9aafa7",
  null
  
)

export default component.exports